<template>
  <div class="wrapper">
    <div class="detail">
      <div class="detail-title">积分明细</div>
      <el-table :data="pointList" style="width: 100%" v-if="pointList.length>0">
        <el-table-column prop="ctime" label="时间" width="200" align="center"></el-table-column>
        <el-table-column prop="num" label="积分" width="100" align="center"></el-table-column>
        <el-table-column prop="type" label="操作" align="center"></el-table-column>
        <el-table-column prop="remarks" label="说明" align="center"></el-table-column>
        <el-table-column prop="balance" label="可用积分" align="center"></el-table-column>
      </el-table>
      <div v-else class="detail-nodata">您还没有任何积分明细记录哦~</div>
    </div>
    <div v-if="pointList.length>0">
      <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
  name: "Point",
  components: { Pagination },
  props: {},
  data() {
    return {
      page: 1,
      limit: 10,
      totalPage: 1,
      pointList: [] // 积分记录
    };
  },
  watch: {},
  computed: {},
  methods: {
    getPointLog() {
      let data = {
        page: this.page,
        limit: this.limit
      };

      this.$api.pointLog(data).then(res => {
        if (res.status) {
          this.totalPage = res.total;
          this.pointList = res.data;
        }
      });
    },
    handOrderMore(val) {
      this.page = val;
      this.getPointLog();
    }
  },
  created() {},
  mounted() {
    this.getPointLog();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .detail {
    &-title {
      color: #757575;
      line-height: 30px;
      margin-top: 10px;
      font-weight: 550;
      border-bottom: 1px solid $border;
    }
    &-nodata {
      margin: 30px auto;
      text-align: center;
    }
  }
}
</style>